import { Link } from "react-router-dom";
import { useI18n } from "../../context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-navy text-cream/70 grain">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="font-sans text-2xl tracking-[0.25em] text-cream mb-4">OMNIA</div>
            <p className="font-editorial text-2xl leading-snug text-cream/90 max-w-md">{t("footer.claim")}</p>
            <p className="mt-6 text-sm text-cream/50 max-w-sm">{t("footer.sub")}</p>
          </div>

          <div>
            <div className="overline text-cream/40 mb-5">{t("footer.ecosystem")}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/marca/gout" className="hover:text-cream transition-colors">GOÛT — Design Intelligence</Link></li>
              <li><Link to="/marca/vetta" className="hover:text-cream transition-colors">VETTA — Product Intelligence</Link></li>
              <li><Link to="/marca/aura" className="hover:text-cream transition-colors">AURA — Living Intelligence</Link></li>
              <li><Link to="/insights" className="hover:text-cream transition-colors">Insights</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-cream/40 mb-5">{t("footer.platform")}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="/#intelligence" className="hover:text-cream transition-colors">{t("footer.designIntel")}</a></li>
              <li><a href="/#metodologia" className="hover:text-cream transition-colors">{t("footer.methodology")}</a></li>
              <li><a href="/#contacto" className="hover:text-cream transition-colors">{t("footer.contact")}</a></li>
              <li><Link to="/login" className="hover:text-cream transition-colors">{t("footer.login")}</Link></li>
              <li><Link to="/terminos" data-testid="footer-terms" className="hover:text-cream transition-colors">{t("footer.terms")}</Link></li>
              <li><Link to="/privacidad" data-testid="footer-privacy" className="hover:text-cream transition-colors">{t("footer.privacy")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-cream/40">
          <span>{t("footer.rights")}</span>
          <span className="tracking-[0.2em]">{t("footer.os")}</span>
        </div>
      </div>
    </footer>
  );
}
